<template>
  <div class="app-showcase-process-step__one">
    <div class="container-fluid container-fluid--cp-150">
      <div class="row flex-column-reverse flex-lg-row align-items-center">
        <div class="col-lg-5 col-md-5">
          <div class="app-showcase-process-step__media text-center wow move-up">
            <img :src="img" class="img-fluid" alt="thumbnail" />
          </div>
        </div>
        <div class="col-lg-7 col-md-7">
          <div class="app-showcase-process-step__content section-space--mt_40">
            <div class="app-showcase__inner">
              <h4 class="font-weight--light wow move-up">{{ title }}</h4>
              <div class="sub-text section-space--mb_40 wow move-up">
                {{ desc }}
              </div>
              <div v-if="!this.loading" class="sub__title mb-20 wow move-up">
                <h6 class="font-weight--blod">{{ subtitle }}</h6>
              </div>
              <div v-if="!this.loading" class="wow move-up">
                <b-button class="scroll btn btn--green"><a href="/login">Log In</a></b-button>
              </div>
              <div v-if="this.loading" class="d-flex wow move-up">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChangeEmailSuccess',
  data() {
    return {
      img: require('../assets/img/hero/startup/top.png'),
      subtitle: '',
      title: 'Password Successfully Changed.',
      desc: '',
    }
  },
  async mounted() {
    if (this.$store.getters.user) {
      this.$router.push('/profile')
    }
  },
}
</script>
